import { render } from "./SelfService.vue?vue&type=template&id=1b283ead"
import script from "./SelfService.vue?vue&type=script&lang=js"
export * from "./SelfService.vue?vue&type=script&lang=js"

import "./SelfService.vue?vue&type=style&index=0&id=1b283ead&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__